import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { searchApi } from '../../api/search';
import { useUserStore } from '../../stores/userStore';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import baseline from '../../app-ui/baseline';

export function useSearchAssist(text, composing = false) {
  const term = text.trim();
  const [settled, setSettled] = useState('');
  const scope = useUserStore((s) => s.user?.id);
  const { locale } = useWebLocale();
  useEffect(() => {
    if (composing) return;
    const timer = setTimeout(() => setSettled(term), baseline.search.debounceMs);
    return () => clearTimeout(timer);
  }, [term, composing]);
  const ready = Boolean(term) && !composing && settled === term;
  const result = useQuery({
    // Switching immediately to an inactive key detaches/aborts the previous request.
    queryKey: ['web-search-results', scope ?? 'guest', locale, 'summary', ready ? term : ''],
    enabled: ready,
    retry: false,
    staleTime: 30_000,
    queryFn: async ({ signal }) =>
      (
        await searchApi.searchSummary(term, {
          signal,
          authenticated: Boolean(scope),
          params: { locale },
        })
      ).data,
  });
  return {
    ...result,
    data: ready ? result.data : undefined,
    waiting: Boolean(term) && (!ready || result.isPending),
  };
}
